export enum PaymentSystem {
  Stripe = 'stripe',
  GMO = 'gmo',
  JTB = 'jtb',
}

export enum BookingPaymentMethod {
  PayOnArrival = 'pay_on_arrival',
  CreditCard = 'credit_card',
  PaymentCard = 'payment_card',
  Combined = 'combined_method',
}

export const PAYMENT_RATES = {
  stripeFee: 2.5,
  minBookingFeeRate: 0,
  maxBookingFeeRate: 20,
  minBookingPoAFeeRate: 0,
  maxBookingPoAFeeRate: 20,
};
